import { getProductCategoryUrl } from '@/url/product';
import Link from 'next/link';
import React from 'react';
import { getImageUrl } from '@/utils/string';
import { imageTypes } from '@/constants/types';
import { useSelector } from 'react-redux';
import ImageComponentV2 from '../Image/ImageComponentV2';
import TextBase from '../Typography/TextBase';

function CategoryCard({ category }) {
  const { lang: selectLang } = useSelector((state) => state.globalSettings);

  return (
    <section
      key={category?.id}
      className="category-card  bg-white w-full min-w-[130px] max-w-[130px] lg:min-w-[164px] lg:max-w-[164px] h-[160px] lg:h-[196px] flex flex-col justify-center items-center gap-[8px] p-6 lg:p-[12px] rounded-xl shadow-trending-categories-search cursor-pointer hover:shadow-card-hover"
    >
      <Link
        prefetch={false}
        aria-label="Go to category page"
        href={`${getProductCategoryUrl({ slug: category.slug })}`}
        passHref
        className="w-full h-full flex flex-col items-center gap-2"
      >
        <ImageComponentV2
          src={
            category?.image?.image ? getImageUrl(category?.image?.image) : null
          }
          alt={`Category name - ${category?.name?.en}`}
          className="w-[96px] h-[96px] lg:w-[124px] lg:h-[124px] flex justify-center items-center"
          type={imageTypes.square}
          width={124}
          height={124}
          loading="lazy"
        />
        <TextBase
          text={category?.name[selectLang] ?? category?.name.en}
          className="text-coarse-wool text-center font-semibold"
        />
      </Link>
    </section>
  );
}

export default CategoryCard;
